import React from 'react';
import { FaHeart, FaCode } from 'react-icons/fa';
import './Signature.css';

const Signature = () => {
  const currentYear = new Date().getFullYear();

  return (
    <section className="signature">
      <div className="container">
        <div className="signature-content">
          <div className="signature-line"></div>
          
          <div className="signature-text">
            <div className="signature-main">
              <span className="signature-name">SKAND SISODIA</span>
              <FaCode className="signature-icon" />
              <span className="signature-title">Software Engineer</span>
            </div>
            
            <div className="signature-message">
              <span>Made with</span>
              <FaHeart className="heart-icon" />
              <span>and lots of coffee</span>
            </div>
            
            <div className="signature-footer">
              <span>&copy; {currentYear} All rights reserved</span>
            </div>
          </div>
          
          <div className="signature-line"></div>
        </div>
      </div>
    </section>
  );
};

export default Signature;
